import React from 'react'

let loaderCompMin = <div>načítám</div>

export const registerLoaderMin = (loader: JSX.Element) => {
  loaderCompMin = loader
}

const LoadingMin = () => {
  return loaderCompMin
}

export default LoadingMin